import { Controller } from '@hotwired/stimulus'

export default class CountProgressController extends Controller {
  static targets = ['circle']

  update(event) {
    const { length, max = 280 } = event.detail
    const inputLength = Math.min(length, max)
    const dashOffset = 100 - (inputLength / max) * 100
    if (this.hasCircleTarget) {
      this.circleTarget.style.strokeDashoffset = dashOffset
    }
  }
}